import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14" aria-labelledby="category-title">
      <div className="flex items-center justify-between mb-6">
        <h2 id="category-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
          分类浏览
        </h2>
        <Link
          to="/category/danmei"
          className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
        >
          全部分类
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors duration-200">
              <i className={`${cat.icon} text-primary-600 text-lg md:text-xl`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500 text-center leading-tight hidden sm:block">
              {cat.description}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}